import type { Person } from '../../../shared/interfaces/people.interface';

import { PermissionsContext } from 'contexts';
import { useCallback, useContext, useEffect } from 'react';
import { openModal } from 'store/modals/modals.slice';
import { getPeopleThunk, getPersonThunk } from 'store/people/people.thunks';

import { MODAL_PEOPLE } from '../../../shared/constants/modals';
import { useAppDispatch, useAppSelector } from '../../../store';
import { vocabulary } from '../../../vocabulary/german';
import { CreateButton } from '../../buttons/create-button/create-button';
import { EntityPanel } from '../../panels/entity-panel/entity-panel';
import { Container } from '../../template/container/container';
import { NotFoundMessage } from '../../template/not-found-message/not-found-message';
import { PageHeader } from '../../template/page-header/page-header';
import { Spinner } from '../../template/spinner/spinner';

export const PeoplePage = () => {
  const dispatch = useAppDispatch();

  const { permissions } = useContext(PermissionsContext);
  const people = useAppSelector((state) => state.people);

  useEffect(() => {
    dispatch(getPeopleThunk());
  }, [dispatch]);

  const handleCreateClick = useCallback(() => {
    dispatch(openModal({ name: MODAL_PEOPLE }));
  }, [dispatch]);

  const handleEdit = useCallback(
    (person: Person) => {
      if (person?.id) {
        dispatch(getPersonThunk(person.id));
        dispatch(openModal({ name: MODAL_PEOPLE }));
      }
    },
    [dispatch],
  );

  const renderCreateButton = () => {
    if (permissions.createNew === true) {
      return (
        <CreateButton
          text={vocabulary.buttons.createNewPeople}
          onClick={handleCreateClick}
        />
      );
    }
    return null;
  };

  const renderEntityPanels = () => {
    if (people.list.length <= 0) {
      return <Spinner />;
    }

    if (people.list.length === 0) {
      return (
        <>
          <NotFoundMessage message="Nicht gefunden: Personen konnten nicht gefunden werden." />
          {renderCreateButton()}
        </>
      );
    }

    return (
      <div className="entities-list">
        {people.list.map((item) => (
          <EntityPanel
            onClick={() => handleEdit(item)}
            key={item.id}
            title={item.name}
            id={item.id}
          />
        ))}
        {renderCreateButton()}
      </div>
    );
  };

  return (
    <div className="page-content">
      <PageHeader
        title={vocabulary.labels.people}
        btnText=""
        downloadReport={null}
      />
      <Container>{renderEntityPanels()}</Container>
    </div>
  );
};
